<template>
    <a href="#" @click.prevent="showMessages()" :class="{'has-notification': displayNotification}">
        <i class="material-icons" data-toggle="tooltip" title="Enviar mensaje">message</i>
    </a>
</template>
<script>
    export default {
        data: function () {
            return {
                displayNotification: this.notification
            }
        },
        props: ['notification', 'page'],
        methods: {
            showMessages () {
                this.displayNotification = false;
                this.$eventHub.$emit('show-messages', this.page);
            }
        }
    }
</script>